import docHostProxy from '../../common/utils/doc-host-proxy';
import { BASE_URL_API, DOC_HOST, } from '../../../base/constants/cgi-base';
// 获取c端用户列表
export var ACCOUNT_LIST = "".concat(BASE_URL_API, "account-list");
// 新的获取用户列表接口
export var SESSION_ACCOUNT_LIST = '/session/api/multiacc/account_list';
// 删除c端账号列表中的账号
export var DEL_ACCOUNT_FOR_LIST = "".concat(DOC_HOST, "/session/logout");
// 获取c端用户列表
export var ENTERPRISE_ACCOUNT_LIST = "".concat(DOC_HOST, "/disklogin/session_list");
// 使用uid获取c端账号微盘id
export var GET_USER_MARK_NAME = "".concat(DOC_HOST, "/sdc/getusermarkname");
// 切换账号后更新更新登录态
export var CHANGE_SIGN = "".concat(docHostProxy(DOC_HOST), "/session/api/multiacc/change-sig");
